import { Container } from 'ui';
import { KoobButton } from '@koob/ui';
import { Stack } from '@koob/margaret';
import { GalleryField, TextField } from '../../../../components/Fields';
import KoobTabs from '../../../../components/Koob/KoobTabs';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FieldArray, useField } from 'formik';
import VisuallyHidden from '../../../../components/VisuallyHidden';
import { useTheme } from 'styled-components';
import { EXPERIENCE_MEDIA_SCHEMA } from '../Utilities/ExperienceValidationSchemas';
import { initialLocale } from '../../../../utils';

export function ExperienceMedia({ currentLocale, isReadOnly = false }) {
  const { t } = useTranslation('experiences');
  const [{ value: mediaLinks }] = useField('mediaLinks');
  const theme = useTheme();

  const tabs = [
    {
      id: 'images',
      label: t('form.images'),
    },
    {
      id: 'links',
      label: t('form.links'),
    },
  ];

  const [currentTab, setCurrentTab] = useState(tabs[0]?.id);

  return (
    <Container size="full">
      <KoobTabs
        tabs={tabs}
        currentTab={currentTab}
        setCurrentTab={setCurrentTab}
      />

      <div className="my-5">
        <Stack gutterSize={1.5}>
          {currentTab === 'images' && (
            <div className="w-full relative">
              {currentLocale.value !== initialLocale.value && (
                <div className="absolute z-10 h-full w-full flex justify-center items-center">
                  <div className="text-orange-500 px-3 py-2 bg-white border border-orange-500 rounded">
                    {t('form.media.selectEnglish')}
                  </div>
                </div>
              )}
              <div
                className={
                  (currentLocale.value !== initialLocale.value || isReadOnly) &&
                  'pointer-events-none opacity-50'
                }
              >
                <GalleryField
                  name="pictures"
                  maximumColumnsCount={3}
                  canSelectMainPicture={true}
                  disabled={isReadOnly}
                />
              </div>
            </div>
          )}

          {currentTab === 'links' && (
            <>
              <FieldArray
                name="mediaLinks"
                render={({ push, remove }) => (
                  <Stack direction="column">
                    {(mediaLinks ?? []).map((link, index) => (
                      <Stack
                        key={index}
                        className="border rounded p-10 m-5"
                        gutterSize={1}
                        alignY="end"
                      >
                        <TextField
                          label={t('form.title')}
                          name={`mediaLinks[${index}].title`}
                          required
                          disabled={isReadOnly}
                        />
                        <TextField
                          label={t('form.linkIndex', { index: index + 1 })}
                          name={`mediaLinks[${index}].link`}
                          required
                          disabled={isReadOnly}
                        />
                        {!isReadOnly && (
                          <KoobButton
                            type="button"
                            variant="secondary"
                            onClick={() => remove(index)}
                            style={{ margin: 'auto' }}
                          >
                            <VisuallyHidden>Delete</VisuallyHidden>
                            <i
                              className="fa-light fa-trash"
                              style={{ fontSize: 20, color: theme.textLighter }}
                            />
                          </KoobButton>
                        )}
                      </Stack>
                    ))}
                    {!isReadOnly && (
                      <KoobButton
                        variant="soft"
                        size="sm"
                        style={{ marginTop: theme.spacing(0.75) }}
                        onClick={() => push('')}
                      >
                        <i
                          className="fa-light fa-circle-plus"
                          style={{ fontSize: 20 }}
                          aria-hidden="true"
                        />{' '}
                        {t('form.addLink')}
                      </KoobButton>
                    )}
                  </Stack>
                )}
              />
            </>
          )}
        </Stack>
      </div>
    </Container>
  );
}

export const getSchema = () => {
  return EXPERIENCE_MEDIA_SCHEMA;
};
